import { createBrowserHistory } from "history";

// import httpService from './interceptor';
// import store from "../redux/store/index";

export const history = createBrowserHistory();
// httpService.setupInterceptors(store, history);



// WEBPACK FOOTER //
// ./src/helper/history.js